module.exports = "<div class=\"container\">\n  <div class=\"box\">\n    <div class=\"logo\">\n      <img src=\"" + require("../../../../public/images/logo_geosiap.png") + "\" width=\"185\" height=\"49\" alt=\"Logo GeoSiap\">\n    </div>\n\n    <h1>Página não encontrada.</h1>\n    <p>A página que você está procurando não foi encontrada.\n      Você pode ter digitado o endereço errado ou a página foi alterada.</p>\n  </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pages/error-page/error-page.component.html
 ** module id = 1051
 ** module chunks = 0
 **/